import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { EventsComponent } from './pages/matrimoni/events.component';
import { ContrattiComponent } from './pages/contratti/contratti.component';
import { EventDetailComponent } from './pages/matrimonio-riepilogo/event-detail.component';
import { CalendarioComponent } from './pages/calendario/calendario.component';
import { ListinoComponent } from './pages/listino/listino.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ProfiloComponent } from './pages/profilo/profilo.component';
import { LoginComponent } from './pages/login/login.component';
import { RegistrazioneComponent } from './pages/registrazione/registrazione.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ConfermaEmailComponent } from './pages/conferma-email/conferma-email.component';
import { CreateEventComponent } from './pages/crea-matrimonio/create-event.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { TestPdfComponent } from './test-pdf/test-pdf.component';
import { AdminComponent } from './pages/admin/admin.component';
import { CookiesComponent } from './cookies/cookies.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { authGuard } from './guard/auth.guard';
import { teamGuard } from './guard/team.guard';
import { OnboardingLayoutComponent } from './layouts/onboarding-layout/onboarding-layout.component';
import { OnboardingComponent } from './pages/onboarding/onboarding.component';
import { ImpostazioniComponent } from './pages/impostazioni/impostazioni.component';
import { AbbonamentiComponent } from './pages/abbonamenti/abbonamenti.component';
import { StatisticheComponent } from './pages/statistiche/statistiche.component';
import { CollaborazioniComponent } from './pages/collaborazioni/collaborazioni.component';
import { TeamLayoutComponent } from './layouts/team-layout/team-layout.component';
import { TeamAttivaComponent } from './pages/team-attiva/team-attiva.component';
import { TeamMatrimoniComponent } from './pages/team-matrimoni/team-matrimoni.component';
import { TeamEventoComponent } from './pages/team-evento/team-evento.component';
import { environment } from '../environments/environment';

const loadLanding = () =>
  import('./pages/landing/landing.component').then((m) => m.LandingComponent);

const landingRoutes: Routes = [
  { path: '', pathMatch: 'full', loadComponent: loadLanding },
  { path: 'privacy-policy', component: PrivacyComponent },
  { path: 'cookie-policy', component: CookiesComponent },
  { path: '**', redirectTo: '' },
];

const appRoutes: Routes = [
  { path: 'landing', loadComponent: loadLanding },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'eventi', component: EventsComponent },
      { path: 'contratti', component: ContrattiComponent },
      { path: 'evento/:id', component: EventDetailComponent },
      { path: 'eventi/nuovo', component: CreateEventComponent },
      { path: 'calendario', component: CalendarioComponent },
      { path: 'listino', component: ListinoComponent },
      { path: 'statistiche', component: StatisticheComponent },
      { path: 'profilo', component: ProfiloComponent },
      { path: 'test-pdf', component: TestPdfComponent },
      { path: 'admin', component: AdminComponent },
      { path: 'cookie-policy', component: CookiesComponent },
      { path: 'privacy-policy', component: PrivacyComponent },
      { path: 'feedback', component: FeedbackComponent },
      { path: 'impostazioni', component: ImpostazioniComponent },
      { path: 'abbonamenti', component: AbbonamentiComponent },
      { path: 'collaborazioni', component: CollaborazioniComponent },
      {
        path: 'novita',
        loadComponent: () =>
          import('./pages/novita/novita.component').then(
            (m) => m.NovitaComponent,
          ),
      },
    ],
  },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'registrazione', component: RegistrazioneComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'conferma-email', component: ConfermaEmailComponent },
    ],
  },
  {
    path: '',
    component: OnboardingLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'onboarding', component: OnboardingComponent },
    ],
  },
  // ── TEAM ──────────────────────────────────────────────────
  {
    path: 'team',
    component: TeamLayoutComponent,
    canActivate: [teamGuard],
    children: [
      { path: 'matrimoni', component: TeamMatrimoniComponent },
      { path: 'evento/:id', component: TeamEventoComponent },
      { path: '', redirectTo: 'matrimoni', pathMatch: 'full' },
    ],
  },
  // ← FUORI da tutti i layout
  {
    path: 'team/attiva',
    component: TeamAttivaComponent,
  },
  {
    path: 'firma/:token',
    loadComponent: () =>
      import('./pages/firma/firma.component').then((m) => m.FirmaComponent),
  },
  // Link corto della firma da mandare alla cliente
  {
    path: 'f/:token',
    loadComponent: () =>
      import('./pages/firma/firma.component').then((m) => m.FirmaComponent),
  },
  // Link corto da mandare alla cliente (es. su WhatsApp)
  {
    path: 'p/:token',
    loadComponent: () =>
      import('./pages/preventivo/preventivo.component').then(
        (m) => m.PreventivoComponent,
      ),
  },
  // Link dei preventivi inviati prima del link corto
  {
    path: 'preventivo/:token',
    loadComponent: () =>
      import('./pages/preventivo/preventivo.component').then(
        (m) => m.PreventivoComponent,
      ),
  },
  { path: '**', component: PageNotFoundComponent },
];

export const routes: Routes = environment.landingOnly ? landingRoutes : appRoutes;
